const renderTimepickerActivity = (state, el) => {
  if (state === 'active') {
    el.classList.add('_active');
    return;
  }

  el.classList.remove('_active');
};

const renderTimepickerFullness = (state, el) => {
  if (state === 'filled') {
    el.classList.add('_filled');
    return;
  }

  el.classList.remove('_filled');
};

const renderTimepickerResult = (timeFrom, timeTo, el) => {
  if (timeFrom && timeTo) {
    el.textContent = `с ${timeFrom} до ${timeTo}`;
  } else if (timeFrom) {
    el.textContent = `с ${timeFrom}`;
  } else if (timeTo) {
    el.textContent = `до ${timeTo}`;
  } else {
    el.textContent = '';
  }
};

const timepicker = (el) => {
  if (!el) {
    return;
  }

  const state = {
    activity: 'idle',
    fullness: 'idle',
    timeFrom: '',
    timeTo: '',
  };

  const timeFromEl = el.querySelector('[data-time="from"]');
  const timeToEl = el.querySelector('[data-time="to"]');
  const resultEl = el.querySelector('.timepicker__result');

  const handleClickOutside = (e) => {
    const timepicker = e.target.closest('.timepicker');

    if (timepicker) {
      return;
    }

    state.activity = 'inactive';
    renderTimepickerActivity(state.activity, el);
  };

  const handlePanelClick = (e) => {
    const panel = e.target.closest('.timepicker__panel');

    if (!panel) {
      return;
    }

    state.activity = state.activity === 'active' ? 'inactive' : 'active';

    renderTimepickerActivity(state.activity, el);
  };

  const handleApply = (e) => {
    const button = e.target.closest('.timepicker__apply');

    if (!button) {
      return;
    }

    const timeFrom = timeFromEl.value;
    const timeTo = timeToEl.value;

    state.timeFrom = timeFrom;
    state.timeTo = timeTo;
    state.activity = 'inactive';
    state.fullness = !timeFrom && !timeTo ? 'unfilled' : 'filled';

    renderTimepickerActivity(state.activity, el);
    renderTimepickerFullness(state.fullness, el);
    renderTimepickerResult(state.timeFrom, state.timeTo, resultEl);
  };

  el.addEventListener('click', handlePanelClick);
  el.addEventListener('click', handleApply);
  document.addEventListener('click', handleClickOutside);
};

const mount = () => {
  const els = Array.from(document.querySelectorAll('.timepicker'));
  els.forEach(timepicker);
};

document.addEventListener('DOMContentLoaded', mount);
